import * as React from 'react';
// import Grid from '@mui/material/Grid';
// import Calendar from '../../Shared/Calendar/Calendar';
// import Appointments from '../Appointments/Appointments';

const DashboardHome = () => {
    // const [date, setDate] = React.useState(new Date())
    return (
        <div>
            <h2>Goriber garir Garage  dashboard</h2>
            <p></p>
        </div>


    );
};

export default DashboardHome;